export default "__VITE_ASSET__CzMJgtcj__"